import React, { useState, useEffect } from 'react';
import api from '../utils/api';

export default function FavouritesView({ showToast, setViewedUserId, setCurrentView }) {
  const [favourites, setFavourites] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFavourites = async () => {
      try {
        setLoading(true);
        const res = await api.get('/favourites');
        setFavourites(res.data.favourites || []);
      } catch (err) {
        console.error('Error fetching favourites:', err);
        showToast('Unable to load saved favourites.');
      } finally {
        setLoading(false);
      }
    };

    fetchFavourites();
  }, []);

  const handleRemoveFavourite = async (targetUserId) => {
    try {
      await api.post(`/favourites/${targetUserId}`);
      setFavourites((prev) => prev.filter((item) => item.user_id !== targetUserId));
      showToast('Removed from favourites.');
    } catch (err) {
      console.error('Failed to remove favourite:', err);
      showToast('Could not remove favourite.');
    }
  };

  const handleProfileClick = (userId) => {
    setViewedUserId(userId);
    setCurrentView('profile');
  };

  if (loading) {
    return <div style={{ color: 'var(--text2)', padding: '20px' }}>Loading saved favourites...</div>;
  }

  return (

    <div className="view active" id="view-favourites">
      <div className="fav-title">Saved Favourites</div>
      <div className="fav-partext">Creatives you've bookmarked.
    </div>
    
    <div className="fav-panel">
      {favourites.length === 0 ? (
        <div style={{ color: 'var(--text3)', fontSize: '14px', fontStyle: 'italic', marginTop: '20px' }}>
          No favourites saved yet. Bookmark creatives to easily find them later!
        </div>
      ) : (
        <div id="fav-list" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {favourites.map((item) => (
            <div 
              key={item.user_id} 
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '12px 16px',
                backgroundColor: 'var(--bg-card, rgba(255,255,255,0.03))',
                borderRadius: '10px',
                border: '1px solid var(--border-color, rgba(255,255,255,0.08))'
              }}
            >
              <div 
                style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer' }}
                onClick={() => handleProfileClick(item.user_id)}
              >
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: 'var(--teal, #00d2c1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: '600',
                  color: '#fff',
                  overflow: 'hidden'
                }}>
                  {item.avatar_url ? (
                    <img src={item.avatar_url} alt={item.display_name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  ) : (
                    item.display_name?.charAt(0) || 'U'
                  )}
                </div>
                <div>
                  <div style={{ fontWeight: '600', color: 'var(--text)', fontSize: '12px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                    {item.display_name}
                    {item.is_verified && <span style={{ color: 'var(--teal)', fontSize: '12px' }}>✦</span>}
                  </div>
                  <div style={{ fontSize: '12px', color: 'var(--text3)' }}>@{item.handle}</div>
                </div>
              </div>

              <div style={{ display: 'flex', gap: '8px' }}>
                <button
                  class="fav-view"  
                  onClick={() => handleProfileClick(item.user_id)}
                  style={{}}
                >
                  View
                </button>
                <button 
                  class="fav-rm" 
                  onClick={() => handleRemoveFavourite(item.user_id)}
                  style={{}}
                >
                  Remove
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
    </div>
  );
}